import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryRepoFileHistoryArgs, RepoFileHistoryOutput } from "types/generated";

export const GET_REPO_FILE_HISTORY: TypedDocumentNode<
  { repoFileHistory: RepoFileHistoryOutput },
  QueryRepoFileHistoryArgs
> = gql`
  query GetRepoFileHistory($repoID: ID!, $filePath: String!, $first: Int, $after: String) {
    repoFileHistory(repoID: $repoID, filePath: $filePath, first: $first, after: $after) {
      edges {
        cursor
        node {
          filePath
          isDeleted
          content {
            content
            isEncrypted
          }
          commit {
            id
            sha
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
